




import mixins from 'vue-typed-mixins';
import HumanResourcesTable from '../HumanResourcesTable.vue';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    HumanResourcesTable,
  },
  props: {
    question: {
      type: Object as () => Question,
    },
  },
  computed: {
    headers(): any[] {
      return [...this.$attrs.headers];
    },
  },
});
